module.exports = __webpack_public_path__ + "img/CanonDeNiebla.3ae91d43.svg";